import { createElement, type SVGProps } from 'react';
import { iconData, type IconName } from './generated/icons';

export interface IconProps extends Omit<SVGProps<SVGSVGElement>, 'name'> {
  name: IconName;
  /** sr-ico (20px) is default; `lg` = 24px (sr-ico--lg). */
  size?: 'md' | 'lg';
  title?: string;
}

/** Outline icon, 24px grid, 1.75 stroke, `currentColor` — renders `.sr-ico` like Serota.icon(). */
export function Icon({ name, size = 'md', className, title, ...rest }: IconProps) {
  const nodes = iconData[name];
  const cls = ['sr-ico', size === 'lg' ? 'sr-ico--lg' : '', className ?? ''].filter(Boolean).join(' ');
  return (
    <svg
      className={cls}
      viewBox="0 0 24 24"
      aria-hidden={title ? undefined : true}
      role={title ? 'img' : undefined}
      {...rest}
    >
      {title ? <title>{title}</title> : null}
      {nodes.map(([tag, attrs], i) => createElement(tag, { key: i, ...attrs }))}
    </svg>
  );
}

export { iconData, iconNames, type IconName } from './generated/icons';
